import Cookies from "js-cookie";

(function($) {
  if ($(".ovu-form").length) {
    // Map siteLang to regional code
    var regionalMap = {
      'NO': 'no',
      'SV': 'sv',
      'DK': 'da',
      'FI': 'fi',
      'EN': 'en'
    };
    
    // Get regional code, fallback to Swedish (primary language)
    var region = regionalMap[siteLang] || 'sv';
    
    // Get the regional settings that were set by datepicker.js
    var settings = $.datepicker.regional[region];
    
    // Extract values from settings for calendar display
    var dateformat = settings.dateFormat;
    var close = settings.closeText;
    var today = settings.currentText;
    var january = settings.monthNames[0];
    var february = settings.monthNames[1];
    var mars = settings.monthNames[2];
    var april = settings.monthNames[3];
    var may = settings.monthNames[4];
    var june = settings.monthNames[5];
    var july = settings.monthNames[6];
    var august = settings.monthNames[7];
    var september = settings.monthNames[8];
    var october = settings.monthNames[9];
    var november = settings.monthNames[10];
    var december = settings.monthNames[11];
    var Sun = settings.dayNamesMin[0];
    var Mon = settings.dayNamesMin[1];
    var Tue = settings.dayNamesMin[2];
    var Wed = settings.dayNamesMin[3];
    var Thu = settings.dayNamesMin[4];
    var Fri = settings.dayNamesMin[5];
    var Sat = settings.dayNamesMin[6];
    var Week = settings.weekHeader;
    
    // Set result format based on language
    var resultFormat = "d M";
    var resultFormatDate = "d";
    
    // Finnish uses different format
    if (region === 'fi') {
      resultFormat = "d. M";
      resultFormatDate = "d.";
    }
    
    // Finnish month names in partitive case (used in date ranges)
    var monthNamesShortFi = [
      "tammikuuta",
      "helmikuuta",
      "maaliskuuta",
      "huhtikuuta",
      "toukokuuta",
      "kesäkuuta",
      "heinäkuuta",
      "elokuuta",
      "syyskuuta",
      "lokakuuta",
      "marraskuuta",
      "joulukuuta"
    ];

    var datePickerOptions = {
      dateFormat: dateformat,
      closeText: close,
      currentText: today,
      monthNames: [
        january,
        february,
        mars,
        april,
        may,
        june,
        july,
        august,
        september,
        october,
        november,
        december
      ],
      dayNamesMin: [Sun, Mon, Tue, Wed, Thu, Fri, Sat],
      weekHeader: Week
    };

    // Note: datepicker input is already initialized by datepicker.js
    // We just need to refresh the ovulation calendar
    refreshCalendar();

    function refreshCalendar(nextMonth) {
      // average ovulation days is 14 days and +/- 2 days
      // previous and most system have used +/- 3 days

      // get default date - current date is default date
      var dateInput = $(".ovu-form #datepicker").val();
      if (dateInput && typeof dateInput !== undefined && dateInput !== "") {
        // Parse date based on format (handle both . and / separators)
        var splitDate;
        if (dateInput.indexOf('/') > -1) {
          // English format: dd/mm/yy
          splitDate = dateInput.split("/");
        } else {
          // Nordic format: dd.mm.yy
          splitDate = dateInput.split(".");
        }
        
        var lastDate = new Date(splitDate[2], splitDate[1] - 1, splitDate[0]);
        var firstMensDate = new Date(lastDate);

        // if date is given and it is next/prev month
        if (nextMonth) {
          var nextMonthDate = Cookies.get("nextMonthDate");
          // Parse cookie date (same separator handling)
          var nextMonthSplit;
          if (nextMonthDate.indexOf('/') > -1) {
            nextMonthSplit = nextMonthDate.split("/");
          } else {
            nextMonthSplit = nextMonthDate.split(".");
          }
          lastDate = new Date(
            nextMonthSplit[2],
            nextMonthSplit[1] - 1,
            nextMonthSplit[0]
          );
        } else {
          Cookies.set("nextMonthDate", dateInput);
        }

        // get constants
        var days = parseInt($(".ovu-form #mens-cycle").val());
        var phase = -3;
        var avgDays = 14;
        var standardDays = 28;
        var resultDays = 6;
        var currentOffset = days - standardDays;
        var offsetDays = avgDays + currentOffset + phase;

        // starting date
        var nextStartDate = new Date(lastDate);
        nextStartDate.setDate(lastDate.getDate() + offsetDays);
        nextStartDate.setHours(0, 0, 0, 0);

        // create default date from next start date,
        // choose 1st day from start date month
        var setDate = new Date(nextStartDate);
        setDate.setDate(setDate.getDate() + 1);
        setDate.setDate(1);

        // end date
        var nextEndDate = new Date(nextStartDate);
        nextEndDate.setDate(nextStartDate.getDate() + resultDays);
        nextEndDate.setHours(0, 0, 0, 0);

        // calculate start and end date for previous month
        var prevDate = new Date(lastDate);
        prevDate.setDate(prevDate.getDate() - days);

        var prevStartDate = new Date(prevDate);
        prevStartDate.setDate(prevStartDate.getDate() + offsetDays);
        prevStartDate.setHours(0, 0, 0, 0);

        var prevEndDate = new Date(prevStartDate);
        prevEndDate.setDate(prevEndDate.getDate() + resultDays);
        prevEndDate.setHours(0, 0, 0, 0);

        // create arrays of dates
        var nextDateArray = getDates(nextStartDate, nextEndDate);
        var prevDateArray = getDates(prevStartDate, prevEndDate);

        $("#ovu-calendar").datepicker("destroy");

        var fertile = 0;

        $("#ovu-calendar").datepicker({
          setDate: setDate,
          defaultDate: setDate,
          gotoCurrent: true,
          showOtherMonths: true,

          monthNames: [
            january,
            february,
            mars,
            april,
            may,
            june,
            july,
            august,
            september,
            october,
            november,
            december
          ],
          dayNamesMin: [Sun, Mon, Tue, Wed, Thu, Fri, Sat],

          onChangeMonthYear: function(year, month) {
            var changedDate = new Date(year, month - 1);
            var currentDate = Cookies.get("nextMonthDate");
            // Parse cookie date (handle both . and / separators)
            var currentDateSplit;
            if (currentDate.indexOf('/') > -1) {
              currentDateSplit = currentDate.split("/");
            } else {
              currentDateSplit = currentDate.split(".");
            }
            currentDate = new Date(
              currentDateSplit[2],
              currentDateSplit[1] - 1,
              currentDateSplit[0]
            );

            Cookies.remove("nextMonthDate");
            // calculate fist mens date for previous and next month
            if (currentDate.valueOf() > changedDate.valueOf()) {
              currentDate.setDate(currentDate.getDate() - days);
            } else {
              currentDate.setDate(currentDate.getDate() + days);
            }
            Cookies.set(
              "nextMonthDate",
              $.datepicker.formatDate("dd.mm.yy", currentDate)
            );

            // refresh calendar with prev/next events
            refreshCalendar(1);
          },
          beforeShowDay: function(date) {
            date.setHours(0, 0, 0, 0);
            if (
              date.valueOf() === lastDate.valueOf() &&
              date.valueOf() === firstMensDate.valueOf()
            ) {
              return [1, "ui-date mens-date"];
            }

            var classes = "ui-date";

            // check if current date is in prevDateArray
            for (var i = 1; i < prevDateArray.length; i++) {
              if (prevDateArray[i].valueOf() === date.valueOf()) {
                classes += " prev-fertile-rate-" + i;
              }
            }

            for (var i = 1; i < nextDateArray.length; i++) {
              if (nextDateArray[i].valueOf() === date.valueOf()) {
                classes += " fertile-rate-" + i;
              }
            }

            return [1, classes];
          }
        });

        fertile = 0;
        $("#ovu-calendar").datepicker("refresh");

        // update text
        var dateText = "";
        var nextStartDate2 = nextStartDate;
        nextStartDate2.setDate(nextStartDate2.getDate() + 1);
        var nextEndDate2 = nextEndDate;
        // - 2 instead of -1 because we don't show day 5 anymore
        nextEndDate2.setDate(nextEndDate2.getDate() - 2);

        if ($.datepicker.regional[region] !== undefined && 'fi' === region) {
          $.extend($.datepicker.regional[region], {monthNamesShort: monthNamesShortFi});
        }

        var startDateText = $.datepicker
          .setDefaults($.datepicker.regional[region])
          .formatDate(resultFormat, nextStartDate2);
        var endDateText = $.datepicker
          .setDefaults($.datepicker.regional[region])
          .formatDate(resultFormat, nextEndDate2);
        // check month, if same month display only once
        if (
          $.datepicker.formatDate("M", nextStartDate2) ===
          $.datepicker.formatDate("M", nextEndDate2)
        ) {
          startDateText = $.datepicker.formatDate(resultFormatDate, nextStartDate2);
        }
        dateText = startDateText + " - " + endDateText;
        $("#pregnancy-chance").text(dateText);
      }
    }

    // update calendar on changing date and
    $(".ovu-form").on("change", "#datepicker, #mens-cycle", function() {
      refreshCalendar();
    });

    // on form submit
    $(".ovu-form").on("submit", function(e) {
      e.preventDefault();
      refreshCalendar();
      $(".ovu-calendar-section, .ovu-pregnancy-text").slideDown();
    });

    // Returns an array of dates between the two dates
    function getDates(startDate, endDate) {
      var dates = [],
        currentDate = startDate,
        addDays = function(d) {
          var date = new Date(this.valueOf());
          date.setDate(date.getDate() + d);
          return date;
        };
      while (currentDate < endDate) {
        dates.push(currentDate);
        currentDate = addDays.call(currentDate, 1);
      }

      return dates;
    }
  } // end check if datepicker exist
})(jQuery);
